// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"b2bcf3d7","568":"cf4bc4b8","984":"a1bc5ca4","990":"32efe34c"}[chunkId] + ".chunk.css";
};